/* eslint-disable indent */
import { SET_AUDIO_MUSIC, SET_SCROLL_ACTIVE_AUDIO } from './constants'

export const initialState = {
  audioState: {
    status: false,
    src: null,
    time: 0,
    newTime: null,
    duration: null,
    podcast: {},
    progress: 0,
    active: false,
  },
  activeScroll: {
    offsetTop: null,
    offsetHeight: null,
  },
}

export const reducer = (state = initialState, action) => {
  const { type, payload } = action

  switch (type) {
    case SET_AUDIO_MUSIC:
      return { ...state, audioState: payload }
    case SET_SCROLL_ACTIVE_AUDIO:
      return { ...state, activeScroll: payload }
    default:
      return state
  }
}
